/**
 * The Sales Tracker's tabs, and their labels.
 *
 * Its own file so that a view can accept an `onGoTab` prop without importing
 * the page that renders it — DashboardView links to Leads and to Reports, and
 * a view importing its own parent is the shape that makes a file split fail to
 * compile.
 */

export type TrackerTab =
  | 'dashboard'
  | 'leads'
  | 'pipeline'
  | 'outreach'
  | 'companies'
  | 'linkedin'
  | 'rounds'
  | 'copy'
  | 'reports';

/**
 * Order matters: the tab strip is rendered from these keys.
 *
 * Kyu, 31 Aug, pointing between two tabs: "put it right in the middle of Leads
 * and Lists." Pipeline sits beside the list it slices rather than beside the
 * Dashboard, because it is the in-the-weeds view of the same people — not
 * another overview.
 */
export const TAB_LABELS: Record<TrackerTab, string> = {
  dashboard: 'Dashboard',
  leads: 'Leads',
  pipeline: 'Pipeline',
  outreach: 'Lists',
  companies: 'Companies',
  // The Tasks tab was removed on 14 September. Sales work now lives on its
  // own page at /sales-tasks, which holds deal and prospect tasks too — this
  // tab could only ever show the tracker's own. The key is gone rather than
  // hidden, so nothing can render a tab with no view behind it; TrackerPage
  // redirects the old URL.
  // Hanneza, 9 Sep: the LinkedIn tab becomes the Prospecting dashboard. The
  // key stays so saved URLs and the counter's query key keep working.
  linkedin: 'Prospecting',
  // Kyu, 11 Sep: "when I click rounds, the rounds view doesn't explain to me
  // what's going on." Beside Prospecting rather than beside Leads, because it
  // is a read of what already happened, not a place work gets done. The Rounds
  // TOGGLE on the leads table stays exactly where it is: that one is the queue.
  rounds: 'Rounds',
  copy: 'Copy Library',
  reports: 'Reports',
};
